import { PreviewCourseList } from './component'

export { PreviewCourseList }
